import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Home, Compass, BookOpen, User } from "lucide-react";
import { useAuth } from "../context/AuthContext";
import { LotusMark } from "./Motif";
import { Button } from "./ui/button";

const TABS = [
  { id: "home", label: "Home", icon: Home, path: "/" },
  { id: "explore", label: "Explore", icon: Compass, path: "/explore" },
  { id: "readings", label: "My Readings", icon: BookOpen, path: "/readings" },
  { id: "profile", label: "Profile", icon: User, path: "/profile" },
];

const TAB_ROUTES = ["/", "/explore", "/readings", "/profile"];

export function Layout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();
  const showBottomNav = TAB_ROUTES.includes(location.pathname);

  return (
    <div className="min-h-screen bg-background">
      {/* Desktop / top nav */}
      <header className="glass-nav sticky top-0 z-40 border-b border-border">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-5 py-4">
          <button
            data-testid="nav-logo"
            onClick={() => navigate("/")}
            className="flex items-center gap-2"
          >
            <span className="flex h-8 w-8 items-center justify-center rounded-full bg-foreground text-background">
              <LotusMark className="h-4 w-4" />
            </span>
            <span className="font-display text-xl font-semibold tracking-tight">Jaanlo</span>
          </button>

          <nav className="hidden items-center gap-7 md:flex">
            <button data-testid="nav-explore" onClick={() => navigate("/explore")} className="text-sm text-muted-foreground transition-colors hover:text-foreground">Explore</button>
            <button data-testid="nav-readings" onClick={() => navigate("/readings")} className="text-sm text-muted-foreground transition-colors hover:text-foreground">My Readings</button>
            <button data-testid="nav-about" onClick={() => navigate("/about")} className="text-sm text-muted-foreground transition-colors hover:text-foreground">About</button>
            {user && user.role === "admin" && (
              <button data-testid="nav-admin" onClick={() => navigate("/admin")} className="text-sm text-muted-foreground transition-colors hover:text-foreground">Admin</button>
            )}
          </nav>

          <Button
            data-testid="nav-ask-cta"
            onClick={() => navigate("/")}
            className="rounded-full bg-foreground px-5 text-background btn-lift hover:bg-foreground"
          >
            Ask a Question
          </Button>
        </div>
      </header>

      <main className={showBottomNav ? "pb-24 md:pb-10" : "pb-10"}>{children}</main>

      {/* Mobile bottom nav */}
      {showBottomNav && (
        <nav className="glass-nav fixed bottom-0 left-0 right-0 z-40 border-t border-border md:hidden">
          <div className="mx-auto flex max-w-lg items-center justify-around px-2 py-2">
            {TABS.map((t) => {
              const Icon = t.icon;
              const active = location.pathname === t.path;
              return (
                <button
                  key={t.id}
                  data-testid={`bottomnav-${t.id}`}
                  onClick={() => navigate(t.path)}
                  className={`flex flex-1 flex-col items-center gap-1 rounded-xl py-1.5 text-[11px] transition-colors ${
                    active ? "text-foreground" : "text-muted-foreground"
                  }`}
                >
                  <Icon className={`h-5 w-5 ${active ? "gold-text" : ""}`} strokeWidth={active ? 2.3 : 1.8} />
                  {t.label}
                </button>
              );
            })}
          </div>
        </nav>
      )}
    </div>
  );
}
